import { Component, EventEmitter, Output } from '@angular/core';
import { ActivityLogService } from '../activity-log/activity-log.service';

@Component({
  selector: 'app-table-activity-log',
  templateUrl: './table-activity-log.component.html',
  styleUrls: ['./table-activity-log.component.scss'],
})
export class TableActivityLogComponent {
  public userId = '';
  public type = '';
  public startDateIso?: string;
  public endDateIso?: string;

  public page = 1;
  public pageSize = 20;
  public total = 0;

  public logs: any[] = [];

  @Output() logsLoaded = new EventEmitter<any[]>();

  constructor(private activityLogService: ActivityLogService) {
    const now = new Date();
    const y = now.getFullYear();
    const m = String(now.getMonth() + 1).padStart(2, '0');
    const d = String(now.getDate()).padStart(2, '0');

    this.startDateIso = `${y}-${m}-${d}T00:00:00`;
    this.endDateIso = `${y}-${m}-${d}T23:59:59`;

    this.getTransactions();
  }

  public getTransactions() {
    const startDate = this.startDateIso ?? '';
    const endDate = this.endDateIso ?? '';

    if (!startDate || !endDate) {
      this.logs = [];
      this.total = 0;
      this.logsLoaded.emit(this.logs);
      return;
    }

    this.activityLogService
      .getLogUserExecution({
        userId: this.userId || undefined,
        type: this.type || undefined,
        startDate,
        endDate,
        page: this.page,
        pageSize: this.pageSize,
      })
      .subscribe((value) => {
        this.logs = (value?.items ?? []) as any[];
        this.total = value?.total ?? this.logs.length;
        this.logsLoaded.emit(this.logs);
      });
  }

  pageChange() {
    this.getTransactions();
  }
}